import { c as _c } from "react/compiler-runtime";
import { debounce } from "es-toolkit";
import { useMemo, useEffect } from "react";

/** Avoid user to click several times */
export const DEBOUNCE_DELAY_MS = 500;

/**
 * Debounced callback for functions that accept a single argument of type T.
 * Forwards all debounce options to es-toolkit debounce.
 * Returns the debounced function.
 */
export function useDebouncedCallback(callback, delay, options) {
  const $ = _c(9);
  let t0;
  if ($[0] !== callback) {
    t0 = function wrapped(value) {
      callback(value);
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const wrapped = t0;
  let t1;
  if ($[2] !== delay || $[3] !== options || $[4] !== wrapped) {
    t1 = debounce(wrapped, delay, options);
    $[2] = delay;
    $[3] = options;
    $[4] = wrapped;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const debouncedFn = t1;
  let t2;
  let t3;
  if ($[6] !== debouncedFn) {
    t2 = () => () => {
      debouncedFn.cancel();
    };
    t3 = [debouncedFn];
    $[6] = debouncedFn;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  return debouncedFn;
}